<template>
    <div class="spackageLocalhostVideoEdit form dialog-form">
        <el-dialog title="添加本地视频" :visible.sync="dialogFormVisible" width="600px">
            <div class="uploadingBtnBox">
                <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                <p class="tips">* 支持MP4格式，文件大小不超过1G。</p>
            </div>
            <div class="progressBar">
                <div class="progressBarItem">
                    <div class="title">
                        <p class="videoName">股权激励实验室第202期培训课程.mp4</p>
                        <div class="action">
                            <p class="progress">50%</p>
                            <p class="delete">删除</p>
                        </div>
                    </div>
                    <el-progress :percentage="50" :show-text="false"></el-progress>
                    <p class="progressNum">已上传:{{item.plan}}/{{item.videoSize}}</p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import UploadFile from 'base/upload/uploadFile'
export default {
    name: 'spackageLocalhostVideoEdit',
    data() {
        return {
            item: {
                name: '',
                vsource: '',
                videoInfo: '',
                plan: 0,
                videoSize: 0
            },
            dialogFormVisible: false,
            uploadVideoType: {
                catecode: '95',
                datatype: 'VIDEO'
            },
            fileRule: {
                btnName: '从本地上传视频',
                cls: '',
                accept: 'video/mp4',
                size: 10,
                width: '',
                height: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        handleSelectionChange() {
        },
        openDialog(row) {
            this.dialogFormVisible = true
        },
        setFile(file) {
            this.item.vsource = '1'
            this.item.videoInfo = file
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UploadFile
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.spackageLocalhostVideoEdit {
    .progressBar{
        min-height: 500px;
        .progressBarItem{
            width: 540px;
            height: 84px;
            box-sizing: border-box;
            border: 1px solid #DCDFE6;
            padding: 10px 20px;
            background: rgba(245,247,250,1);
            margin-top: 20px;
            .title{
                display: flex;
                justify-content: space-between;
                margin-bottom: 12px;
                .action{
                    display: flex;
                    color: #409EFF;
                    .progress{
                        margin-right: 20px;
                    }
                    .delete{
                        cursor: pointer;
                    }
                }
            }
            .progressNum{
                margin-top: 12px;
                color: #409EFF;
            }
        }
    }
    .el-dialog{
        min-height: 600px;
        width: 580px !important;
    }
    .uploadingBtnBox{
        text-align: center;
        .uploadFile{
            .upload-demo{
                margin: 0 auto;
            }
        }
        .el-button{
            width: 138px;
            margin-bottom: 10px;
        }
        .tips{
            color: #C0C4CC;
            font-size: 12px;
        }
    }
}
</style>
